import React, { useCallback, useRef, useEffect, useState } from 'react';

import { FiMail } from 'react-icons/fi';
import { Container } from './styles';
import Vimeo from '../Vimeo';
import { Button } from '../Button/styles';
import { useModal } from '../../hooks/Modal';
import SendEmailToPoster from '../SendEmailToPoster';
import { Modal } from '../ModalContainer/styles';
import ChatRoom from '../Chat';
import { useLanguage } from '../../hooks/Language';
import { urlWebsite } from '../../config';
import { FaThumbsUp } from 'react-icons/fa';
import { useToast } from '../../hooks/Toast';
import Loader from '../Loader';
import api from '../../services/api';
import { useConfiguration } from '../../hooks/Configuration';
import IframePlayer from '../IframePlayer';
import Youtube from '../Youtube';

interface IPoster {
  _id: string;
  id: number;
  title?: string;
  author?: string;
  image?: string;
  video_type?: number;
  video_id: string;
  co_authors?: string;
  category?: string;
  have_video?: string;
  formatted_date?: string;
  formatted_start_hour?: string;
  room_id?: string;
  hash?: string;
  description?: string;
  institution?: string;
  eixo?: string;
}

interface IZoomPoster {
  posterItem: IPoster;
  closePoster: Function;
}

const PosterZoomComponent: React.FC<IZoomPoster> = ({
  posterItem,
  closePoster,
}) => {
  const { addModal } = useModal();
  const [translateX, setTranslateX] = useState(0);
  const [translateY, setTranslateY] = useState(0);
  const [scaleImg, setScaleImg] = useState(100);
  const [typeImg, setTypeImg] = useState(1);
  const [active, setActive] = useState(false);
  const { translate } = useLanguage();
  const { configuration } = useConfiguration();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const elementsItems = [
    {
      name: 'Parte 1',
      type: 1,
      transform: ` scale(1) translateX(0) translateY(0)`,
      top: 0,
      left: 0.3,
      width: 47,
      height: 50,
    },
    {
      name: 'Parte 2',
      type: 1,
      transform: ` scale(1) translateX(0) translateY(0)`,
      top: 0,
      left: 35,
      width: 47,
      height: 50,
    },
    {
      name: 'Parte 3',
      type: 1,
      transform: ` scale(1) translateX(0) translateY(0)`,
      top: 50,
      left: 0.3,
      width: 47,
      height: 50,
    },

    {
      name: 'Parte 4',
      type: 1,
      transform: ` scale(1) translateX(0) translateY(0)`,
      top: 50,
      left: 35,
      width: 47,
      height: 50,
    },
  ];

  const [renderer, setRenderer] = useState(elementsItems);
  const [indexer, setIndexer] = useState([0, 2]);

  const zoom = (index: number, type: number) => {
    setIndexer([index, type]);
    const elements = [...elementsItems];
    const element = { ...elementsItems[index] };
    const { width, height, left, top } = element;

    const vetor = 95 / width;
    const getScale = vetor * 100;

    elements.map((elementIt, indexIt) => {
      elements[indexIt].type = 1;
    });

    element.type = type === 1 ? 2 : 1;
    // window.scrollTo(0, 0);

    elements.splice(index, 1, element);
    const tvetor = 1080 / 1920;
    const tX =
      left * vetor < 0 ? (left * vetor - 2.5) * -1 : left * vetor - 2.5;
    console.log(index, tX);

    setTranslateX(type === 1 ? left * (type === 1 ? 2.8 : 1) : 0);
    setTranslateY(type === 1 ? top * 0.5 * vetor : 0);
    setScaleImg(type === 1 ? getScale : 100);
    setTypeImg(type === 1 ? 2 : 1);
    setRenderer([...elements]);
  };
 

  const showForm = () => {
    addModal({
      key: 'messageToPoster',
      title: translate('Enviar Mensagem'),
      content: <SendEmailToPoster hash={posterItem.hash} callback={() => { }} />,
    });
  };

  const votePoster = async (id) => {
    setLoading(true)
    try {
      await api.post(`send-poster-vote/${id}`);
      addToast({ title: 'Voto enviado com sucesso!', type: 'success' });
      setLoading(false);
    }
    catch (err) {
      addToast({ title: err?.response?.data?.message || err?.response?.data?.error || err?.response?.data?.erro || 'Erro ao enviar voto', type: 'error' });
      setLoading(false);
    }


  }


  const posterView = async (id) => {

    await api.post(`send-poster-view/${id}`);



  }

  useEffect(() => {
    if (posterItem?._id) {
      posterView(posterItem?._id)
    }
  }, [posterItem])

  return (
    <Container>
      {loading ? <Loader message='Carregando...' /> : <></>}
      <div className="textContent" style={{maxWidth:'1000px'}}>
        <p className="title">
          <strong>
            ID:
            <br />
          </strong>
          {posterItem._id?.toString()}
        </p>
        <p className="title">
          <strong>
            {translate('Título')}:
            <br />
          </strong>
          {posterItem.title}
        </p>
        <p>
          <strong>
            {translate('Autor')}:
            <br />
          </strong>

          {posterItem.author}
        </p>

        <p>
          <strong>
            {translate('Coautores')}:
            <br />
          </strong>

          {posterItem.co_authors}
        </p>

        {posterItem.institution ? <p>
          <strong>
            {translate('Instituição')}:
            <br />
          </strong>

          {posterItem.institution}
        </p> : <></>}

        {posterItem.eixo ? <p>
          <strong>
            {translate('Área')}:
            <br />
          </strong>

          {posterItem.eixo}
        </p> : <></>}

        {/* posterItem.description ? <p>
          <strong>
            {translate('Descritivo')}:
            <br />
          </strong>
          <p dangerouslySetInnerHTML={{ __html: posterItem.description }} />

        </p> : <></> */}

        <div>
          {/* <Button type="button" onClick={() => setActive(true)}>
            <FiMail />
            {' '}
            {translate('Enviar Mensagem')}
          </Button>

  */}
          <div className='activeButton' style={{ width: '200px', textAlign: 'center' }} onClick={() => configuration?.theme_data?.allow_poster_vote === 'open' ? votePoster(posterItem?._id?.toString()) : false}  > {configuration?.theme_data?.allow_poster_vote === 'open' ? <> Votar <FaThumbsUp style={{ marginLeft: '5px' }} /></> : configuration?.theme_data?.allow_poster_vote === 'finished' ? 'Votação encerrada' : 'Votação em breve'}</div>

        </div>
        {posterItem.category !== 'Pôster Simples' && (
          <>

          </>
        )}
      </div>

 
      <div className="posterPlace">
        {posterItem.have_video !== 'yes' ? (
          <>
            <div style={{ display: 'flex' , justifyContent:'center', width: '100%'}}>
             
              <div className="posterBlock">
                <div
                  className="posterDiv"
                  style={{
                    width: `100%`,
 
                  }}
                >
                  

                  <img
                    className="posterImage"
                    src={`${urlWebsite}/${posterItem.image}`}
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div style={{ background: "rgb(250,250,250)", width: '100%' }}><Youtube id={posterItem.video_id} /></div>
        )}

      
      </div>
      {active && (
        <Modal style={{ zIndex: 10000000 }}>
          <div style={{ background: '#fff' }}>
            <SendEmailToPoster
              hash={posterItem.hash}
              callback={() => setActive(false)}
            />
            <button
              className="closeButton"
              type="button"
              onClick={() => setActive(false)}
            >
              Fechar
            </button>
          </div>
        </Modal>
      )}
    </Container>
  );
};

export default PosterZoomComponent;
